<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bmE0SK/tc-custom/9781466816145.jpg?1737749026899" alt="This image is the cover for the book On the Head of a Pin, From Crosstown to Oblivion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On the Head of a Pin, From Crosstown to Oblivion
      </h1>
      <p class="bookDescription body article font2">
        <b>An innovative new filmmaking technology unlocks a terrifying new world in this science fiction novella by an award-winning author.</b><br/><br/>In Walter Mosley’s <i>On the Head of a Pin</i>, Joshua Winterland and Ana Fried are working at Jennings-Tremont Enterprises when they make the most important discovery in the history of this world—or possibly the next. JTE is developing advanced animatronics editing techniques to create high-end movies indistinguishable from live-action. Long dead stars can now share the screen with today’s A-list. But one night Joshua and Ana discover something lingering in the rendered footage . . . an entity that will lead them into a new age beyond the reality they have come to know . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter Mosley
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;&amp;lt;B&amp;gt;Walter Mosley&amp;lt;/B&amp;gt; is one of America's most celebrated and beloved writers. A Grand Master of the Mystery Writers of America, he has won numerous awards, including the Anisfield-Wolf Award, a Grammy, a PEN USA's Lifetime Achievement Award, and several NAACP Image Awards. His books have been translated into more than twenty languages.   His short fiction has appeared in a wide array of publications, including &amp;lt;I&amp;gt;The New Yorker, GQ, Esquire, Los Angeles Times Magazine,&amp;lt;/I&amp;gt; and &amp;lt;I&amp;gt;Playboy,&amp;lt;/I&amp;gt; and his nonfiction has been published in &amp;lt;I&amp;gt;The New York Times Book Review, The New York Times Magazine, Newsweek,&amp;lt;/I&amp;gt; and &amp;lt;I&amp;gt;The Nation&amp;lt;/I&amp;gt;. He is the author of, most recently, &amp;lt;I&amp;gt;Down the River unto the Sea&amp;lt;/I&amp;gt;. He lives in New York City.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a25c69e2